/**
 * Browser-safe search metadata resolution. This leaf deliberately imports
 * nothing so themed SSR, app-host heads, and draft previews can share it.
 */
export const META_DESCRIPTION_MAX = 160;

const MIN_WORD_SAFE_SNIPPET = Math.floor(META_DESCRIPTION_MAX / 2);

export function metaDescriptionFor(post: {
  description: string;
  summary: string;
}): string {
  const description = post.description.trim();
  if (description) return description;
  const summary = post.summary.trim();
  if (summary.length <= META_DESCRIPTION_MAX) return summary;
  const cut = summary.slice(0, META_DESCRIPTION_MAX - 1);
  const lastBreak = /^([\s\S]*)\s/.exec(cut);
  const wordSafe = (lastBreak?.[1] ?? "").trimEnd();
  const head =
    wordSafe.length >= MIN_WORD_SAFE_SNIPPET ? wordSafe : cut.trimEnd();
  return `${head}…`;
}

type SearchAppearanceInput =
  | {
      kind: "blog";
      blog: {
        title: string;
        description: string;
        seoTitle?: string | null;
        seoDescription?: string | null;
      };
    }
  | {
      kind: "post";
      post: {
        title: string;
        seoTitle?: string | null;
        description: string;
        summary: string;
      };
    };

export function searchAppearanceFor(
  input: SearchAppearanceInput,
): { title: string; description: string } {
  if (input.kind === "blog") {
    return {
      title: input.blog.seoTitle?.trim() || input.blog.title,
      description:
        input.blog.seoDescription?.trim() || input.blog.description.trim(),
    };
  }
  return {
    title: input.post.seoTitle?.trim() || input.post.title,
    description: metaDescriptionFor(input.post),
  };
}
